// pages/Applications.jsx
import React from 'react';
import ApplicationList from '../components/applications/ApplicationList';

const Applications = () => {
    return <ApplicationList />;
};

export default Applications;